import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Fonts, getColor } from 'core/utils/Styles';
import { StyledSubNavListItem } from './subNavStyles';

class SubNavListItem extends PureComponent {
	render() {
		return (
			<StyledSubNavListItem href={this.props.href}>
				{this.props.text}
			</StyledSubNavListItem>
		);
	}

	static propTypes = {
		text: PropTypes.string.isRequired,
		href: PropTypes.string.isRequired,
		parentSlug: PropTypes.string.isRequired,
	}
}

export default SubNavListItem;
